export default __webpack_public_path__ + "static/media/indicator-sect5-heading.fd1e16a8.svg";